import {
    CreateWebhookRequest,
    UpdateWebhookRequest,
    CreateWebhookEndpointRequest,
    UpdateWebhookEndpointRequest,
    BulkCreateEndpointRequest,
    WebhookFilters,
    WebhookEndpointFilters,
    WebhookLogFilters,
} from "../types/webhook";

export const webhookEndpoints = {
    getWebhooks: {
        query: (filters: WebhookFilters) => ({
            url: "/admin/webhooks",
            params: filters,
        }),
    },

    getWebhook: {
        query: (id: number) => `/admin/webhooks/${id}`,
    },

    createWebhook: {
        query: (webhook: CreateWebhookRequest) => ({
            url: "/admin/webhooks",
            method: "POST",
            body: webhook,
        }),
    },

    updateWebhook: {
        query: (params: { id: number; data: UpdateWebhookRequest }) => ({
            url: `/admin/webhooks/${params.id}`,
            method: "PUT",
            body: params.data,
        }),
    },

    deleteWebhook: {
        query: (id: number) => ({
            url: `/admin/webhooks/${id}`,
            method: "DELETE",
        }),
    },

    getWebhookLogs: {
        query: (params: { id: number; filters: WebhookLogFilters }) => ({
            url: `/admin/webhooks/${params.id}/logs`,
            params: params.filters,
        }),
    },

    testWebhook: {
        query: (id: number) => ({
            url: `/admin/webhooks/${id}/test`,
            method: "POST",
        }),
    },

    toggleWebhookStatus: {
        query: (id: number) => ({
            url: `/admin/webhooks/${id}/toggle`,
            method: "POST",
        }),
    },

    getWebhookEventTypes: {
        query: () => "/admin/webhooks/event-types",
    },

    getWebhookStats: {
        query: () => "/admin/webhooks/stats",
    },

    // Webhook Endpoints (Global)
    getWebhookEndpoints: {
        query: (filters: WebhookEndpointFilters) => ({
            url: "/admin/webhook-endpoints",
            params: filters,
        }),
    },

    getWebhookEndpoint: {
        query: (id: number) => `/admin/webhook-endpoints/${id}`,
    },

    createWebhookEndpoint: {
        query: (endpoint: CreateWebhookEndpointRequest) => ({
            url: "/admin/webhook-endpoints",
            method: "POST",
            body: endpoint,
        }),
    },

    updateWebhookEndpoint: {
        query: (params: {
            id: number;
            data: UpdateWebhookEndpointRequest;
        }) => ({
            url: `/admin/webhook-endpoints/${params.id}`,
            method: "PUT",
            body: params.data,
        }),
    },

    deleteWebhookEndpoint: {
        query: (id: number) => ({
            url: `/admin/webhook-endpoints/${id}`,
            method: "DELETE",
        }),
    },

    getWebhookEndpointLogs: {
        query: (params: { id: number; filters: WebhookLogFilters }) => ({
            url: `/admin/webhook-endpoints/${params.id}/logs`,
            params: params.filters,
        }),
    },

    testWebhookEndpoint: {
        query: (id: number) => ({
            url: `/admin/webhook-endpoints/${id}/test`,
            method: "POST",
        }),
    },

    toggleWebhookEndpointStatus: {
        query: (id: number) => ({
            url: `/admin/webhook-endpoints/${id}/toggle`,
            method: "POST",
        }),
    },

    getWebhookEndpointStats: {
        query: () => "/admin/webhook-endpoints/stats",
    },

    // Webhook Endpoints (Related to specific webhook)
    getWebhookEndpointsByWebhook: {
        query: (params: {
            webhookId: number;
            filters: WebhookEndpointFilters;
        }) => ({
            url: `/admin/webhooks/${params.webhookId}/endpoints`,
            params: params.filters,
        }),
    },

    createWebhookEndpointForWebhook: {
        query: (params: {
            webhookId: number;
            data: Omit<CreateWebhookEndpointRequest, "webhook_id">;
        }) => ({
            url: `/admin/webhooks/${params.webhookId}/endpoints`,
            method: "POST",
            body: params.data,
        }),
    },

    bulkCreateWebhookEndpoints: {
        query: (params: {
            webhookId: number;
            data: BulkCreateEndpointRequest;
        }) => ({
            url: `/admin/webhooks/${params.webhookId}/endpoints/bulk`,
            method: "POST",
            body: params.data,
        }),
    },
};

export const webhookTags = [
    "Webhooks",
    "WebhookEndpoints",
    "WebhookLogs",
] as const;
